module.exports = __webpack_public_path__ + "static/img/zggl.69bb95f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zggl.png
// module id = 4h7a
// module chunks = 0